import { IGroupHealthInsuranceDependentsValues } from '../../../../../types';

export const INITIAL_VALUES: IGroupHealthInsuranceDependentsValues = {
  organization: 0,
  dependent: undefined,
  first_name: '',
  last_name: '',
  turkish_id: '',
  birthday: '',
  gsm: '',
  gender: '',
  nationality: '',
  start_date: '',
  end_date: '',
  payment: '',
  recent_status: '',
  email_users: [],
  upload_files: [],
};
